import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLoyalty } from '../../api/queries.js';
import './Loyalty.css';

export default function Loyalty() {
  const [page, setPage] = useState(1);
  const { data, isLoading, isError } = useLoyalty(page);

  const points = data?.points ?? 0;
  const nextRewardAt = data?.nextRewardAt ?? 100;
  const progress = nextRewardAt > 0 ? Math.min((points / nextRewardAt) * 100, 100) : 0;
  const history = data?.history || [];
  const totalPages = data?.totalPages || 1;

  return (
    <div className="container" style={{ paddingTop: 'var(--space-6)', paddingBottom: 'var(--space-8)', maxWidth: 600, margin: '0 auto' }}>
      <h1 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700, marginBottom: 'var(--space-3)' }}>
        Ma fidelite
      </h1>

      {/* Carte de fidelite */}
      <div className="loyalty-card-wrapper">
        <div className="loyalty-card">
          <div className="loyalty-card-header">
            <span className="loyalty-card-label">Carte de fidelite WAW</span>
            <span className="loyalty-sparkle">&#10024;</span>
          </div>
          <div className="loyalty-points-display">
            {isLoading ? (
              <span className="skeleton" style={{ display: 'inline-block', width: 80, height: 48 }} />
            ) : (
              <span className="loyalty-points-number">{points}</span>
            )}
            <span className="loyalty-points-unit">points</span>
          </div>
          <div className="loyalty-progress-wrapper">
            <div className="loyalty-progress-bar">
              <div
                className="loyalty-progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="loyalty-progress-labels">
              <span>0</span>
              <span>Prochaine recompense : {nextRewardAt} pts</span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginBottom: 'var(--space-4)' }}>
        <Link to="/compte/fidelite/echanger" className="btn btn-primary">
          Echanger mes points
        </Link>
      </div>

      {/* Historique */}
      <h2 style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, marginBottom: 'var(--space-2)' }}>
        Historique
      </h2>

      {isLoading && (
        <div style={{ display: 'grid', gap: 'var(--space-1)' }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="skeleton" style={{ height: 48, borderRadius: 'var(--radius-client)' }} />
          ))}
        </div>
      )}

      {isError && (
        <p style={{ color: 'var(--waw-pink)', textAlign: 'center' }}>
          Impossible de charger l'historique.
        </p>
      )}

      {!isLoading && !isError && history.length === 0 && (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 'var(--space-3)' }}>
          Aucune activité pour le moment.
        </p>
      )}

      {history.length > 0 && (
        <div style={{ display: 'grid', gap: 'var(--space-1)' }}>
          {history.map((entry, i) => (
            <div
              key={entry.id || i}
              className="card"
              style={{
                padding: 'var(--space-2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <div style={{ fontSize: 'var(--font-size-sm)', fontWeight: 500 }}>
                  {entry.label || entry.type}
                </div>
                <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' }}>
                  {entry.date}
                </div>
              </div>
              <span
                style={{
                  fontWeight: 700,
                  fontSize: 'var(--font-size-base)',
                  color: entry.amount > 0 ? 'var(--status-confirmed)' : 'var(--waw-pink)',
                }}
              >
                {entry.amount > 0 ? '+' : ''}{entry.amount}
              </span>
            </div>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 'var(--space-1)', marginTop: 'var(--space-3)' }}>
          <button
            className="btn btn-secondary btn-sm"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <span style={{ display: 'flex', alignItems: 'center', padding: '0 var(--space-2)', fontSize: 'var(--font-size-sm)', color: 'var(--text-muted)' }}>
            {page} / {totalPages}
          </span>
          <button
            className="btn btn-secondary btn-sm"
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      )}
    </div>
  );
}
